<template>
  <div class="flex">
    <!-- Content Area -->
    <div class="w-full p-6 flex flex-col">
      <!-- Header Section -->
      <header class="p-2 flex items-center justify-between rounded-md">
        <div class="w-1/4 mr-2">
          <router-link to="/dashboard">
              <img src="@/assets/logo.png" class="block h-auto max-w-full">
          </router-link>
        </div>

        <div class="w-full max-w-2xl mx-auto flex justify-center">
          <input type="text" placeholder="Search..." class="border-solid border-2 border-gray-600 bg-secondary w-full rounded-md text-black focus:outline-none focus:ring-2 focus:ring-blue-500 px-4 py-2 my-2">
        </div>

        <div class="w-2/6">
          <select class="w-5/6 text-primary mx-3 rounded-md border-2 px-4 py-2 focus:border-white my-2 font-bold" @change="handleSelection">
            <option value="" selected hidden>{{ user.name }}</option>
            <option value="update">Change Password</option>
            <option value="logout">Logout</option>
          </select>
        </div>
      </header>

      <!-- Navbar Section -->
      <div class="bg-primary rounded-lg mx-2 my-4 items-center justify-between">
        <nav class="text-white p-2 flex justify-start">
          <div class="text-2xl font-semibold mx-6">
            Welcome, <span class="font-bold">{{ user.name }}</span>
          </div>
        </nav>
        <nav class="text-white">
          <div class="flex justify-start mx-6 py-2 space-x-4">
            <router-link to="/dashboard" class="text-white">Home</router-link>
            <router-link to="/bank-accounts" class="text-white">Accounts</router-link>
            <router-link to="/beneficiary" class="text-white">Payments</router-link>
            <!-- <router-link to="" class="text-white">Requests</router-link> -->
          </div>
        </nav>
      </div>

      <!-- Sidebar and Main Content Section -->
      <div class="flex">
        <!-- Sidebar -->
        <div class="bg-secondary border-solid border-2 border-gray-600 text-primary flex flex-col w-1/4 h-screen p-4 rounded-md text-center overflow-y-auto">
          <ul class="uppercase">
              <!-- Dashboard -->
              <li class="mb-4 mt-2 border-b border-gray-600 pb-2 pt-2 bg-blue-100 rounded-md">
                  <router-link to="/dashboard"><h6 class="font-bold text-primary " href=""><i class="fa fa-cog mr-4" aria-hidden="true"></i>Quick Links</h6></router-link>
              </li>

              <!-- My Accounts -->
              <li class="mb-4 mt-2 border-b border-gray-600 pb-2 pt-2">
                  <router-link to="/bank-accounts" class="text-primary"><div class="font-bold cursor-pointer"><i class="fa fa-users mr-4" aria-hidden="true"></i>My Accounts</div></router-link>
              </li>

              <!-- Fund Transfer -->
              <li class="mb-4 mt-2 border-b border-gray-600 pb-2 pt-2">
                  <router-link to="/beneficiary" class="text-primary"><div class="font-bold cursor-pointer"><i class="fa fa-exchange mr-4" aria-hidden="true"></i>Fund Transfer</div></router-link>
              </li>

              
              <li class="mb-4 mt-2 pb-2 pt-2">
                  <router-link to="/account-details" class="text-primary"><div class="font-bold cursor-pointer"><i class="fa fa-user mr-4" aria-hidden="true"></i>My Profile</div></router-link>
              </li>

              <!-- Calendar -->
              <li class="mt-20 text-center border-t border-gray-600 pb-4">
                  <h2 class="text-lg font-bold bg-blue-100 p-2 rounded-md inline-block">My Calender</h2>
                  <div class="mt-4">
                      <div class="font-semibold capitalize">{{ currentDateTime }}</div>
                  </div>
              </li>
          </ul>
        </div>

        <!-- Main Content -->
        <div class="w-4/5 p-6 bg-secondary border-solid border-2 border-gray-600 text-primary flex flex-col h-screen p-4 rounded-md overflow-y-auto mx-4">
          <!-- Main Content Goes Here -->
          <div class="content-area">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>


export default {
  name : 'DashboardLayout',
  props:{
      user: Object,
  },
  data() {
      return {
          dropdowns: {
              accounts: false,
              fundTransfer: false,
              transaction:false,
              profile:false,
              requests: false,
          },
          currentDateTime: "",
      };
  },
  methods: {
      handleSelection(event){
          const selectedValue = event.target.value;

          if(selectedValue == 'update'){
              this.$router.push('/update-profile');
          }else if(selectedValue == 'logout'){
              this.logout();
          }
      },
      logout(){
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          this.$router.push("/");
      },
      toggleDropdown(option) {
          for (let key in this.dropdowns) {
              if (key === option) {
                  // Toggle only the clicked dropdown
                  this.dropdowns[key] = !this.dropdowns[key];
              } else {
                  // Close all other dropdowns
                  this.dropdowns[key] = false;
              }
          }

      },
      updateDateTime() {
          const now = new Date();
          const options = { weekday: "short", month: "short", day: "numeric", year: "numeric" };
          this.currentDateTime = now.toLocaleDateString("en-US", options); // Formats date and time
      },
  },
  mounted() {
      this.updateDateTime();
  },

};
</script>

<style scoped>
  .gradient-text {
      background: linear-gradient(to right, orange 20%, yellow 50%, green 80%);
      -webkit-background-clip: text;
      color: transparent;
      font-weight: bold; /* Optional: make the text bold */
      font-size: 2.25rem; /* Optional: adjust size */
      text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
  }
</style>